export function detachExtensionFromFilename(filename) {
    var basename = filename.split(/[\\/]/).pop();
    var dotIndex = basename.lastIndexOf('.');
    var fileExtension = basename === '' || dotIndex < 1 ? '' : basename.slice(dotIndex + 1);
    return {
        filename: filename.substring(0, dotIndex) || filename,
        fileExtension: fileExtension,
    };
}
export function appendToFilename(filename, string) {
    var dotIndex = filename.lastIndexOf('.');
    if (dotIndex === -1)
        return filename + string;
    else
        return (filename.substring(0, dotIndex) + string + filename.substring(dotIndex));
}
